import * as React from "react"
import { gql } from "@apollo/client"
import { Button } from "@chakra-ui/react"

import {
  ConnectionStatus,
  GetUserDocument,
  useRemoveConnectionMutation,
  useRequestConnectionMutation,
  UserProfileFragment,
} from "lib/graphql"
import { useMutationHandler } from "lib/hooks/useMutationHandler"

const _ = gql`
  mutation RequestConnection($userId: String!) {
    requestConnection(userId: $userId)
  }

  mutation RemoveConnection($userId: String!) {
    removeConnection(userId: $userId)
  }
`

interface Props {
  user: UserProfileFragment
}

export function UserConnectActions(props: Props) {
  const handler = useMutationHandler()
  const [requestConnect, { loading: requestLoading }] = useRequestConnectionMutation({
    refetchQueries: [{ query: GetUserDocument, variables: { id: props.user.id } }],
  })
  const [removeConnect, { loading: removeLoading }] = useRemoveConnectionMutation({
    refetchQueries: [{ query: GetUserDocument, variables: { id: props.user.id } }],
  })

  const handleRequestConnect = () => {
    return handler(() => requestConnect({ variables: { userId: props.user.id } }), {
      onSuccess: (_, toast) => toast({ description: "Verzoek verstuurd" }),
    })
  }
  const handleRemoveConnect = () => {
    return handler(() => removeConnect({ variables: { userId: props.user.id } }), {
      onSuccess: (_, toast) => toast({ description: "Verzoek geannuleerd" }),
    })
  }

  switch (props.user.connectionStatus) {
    case "NOT_REQUESTED":
      return (
        <Button
          size="xs"
          variant="outline"
          isLoading={requestLoading}
          isDisabled={requestLoading}
          onClick={handleRequestConnect}
        >
          Connect
        </Button>
      )
    case ConnectionStatus.Accepted:
      return (
        <Button
          size="xs"
          variant="outline"
          isLoading={removeLoading}
          isDisabled={removeLoading}
          onClick={handleRemoveConnect}
        >
          Disconnect
        </Button>
      )
    case ConnectionStatus.Pending:
      return (
        <Button
          size="xs"
          variant="outline"
          isLoading={removeLoading}
          isDisabled={removeLoading}
          onClick={handleRemoveConnect}
        >
          Pending - Annuleren
        </Button>
      )
    case ConnectionStatus.Rejected:
      return null
    default:
      // TODO: loginform
      return <></>
  }
}
